import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mtm-delete-model-confirmation-modal',
  templateUrl: './delete-model-confirmation-modal.component.html',
  styleUrl: './delete-model-confirmation-modal.component.scss',
  standalone: false,
})
export class DeleteModelConfirmationModalComponent {
  @Input() modelName: string = '';
  @Output() confirmDelete = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onConfirmDelete(): void {
    this.confirmDelete.emit();
    this.activeModal.close();
  }
}
